export default "__VITE_ASSET__ZRGPF7ec__"